var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavCollaborate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8333,
    cy: 10.7222,
    r: 4.2222,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 25.5V23.3889C6.5 22.2691 6.94484 21.1951 7.73666 20.4033C8.52848 19.6115 9.60242 19.1667 10.7222 19.1667H14.9444C16.0642 19.1667 17.1382 19.6115 17.93 20.4033C18.7218 21.1951 19.1667 22.2691 19.1667 23.3889V25.5M20.2222 6.6371C21.1304 6.86964 21.9354 7.39784 22.5103 8.13843C23.0851 8.87901 23.3972 9.78986 23.3972 10.7274C23.3972 11.6649 23.0851 12.5757 22.5103 13.3163C21.9354 14.0569 21.1304 14.5851 20.2222 14.8177M25.5 25.4999V23.3888C25.4946 22.4569 25.1811 21.553 24.6083 20.8179C24.0355 20.0828 23.2356 19.5579 22.3333 19.3249M8.61111 10.7222C8.61111 11.842 9.05595 12.916 9.84777 13.7078C10.6396 14.4996 11.7135 14.9444 12.8333 14.9444C13.9531 14.9444 15.0271 14.4996 15.8189 13.7078C16.6107 12.916 17.0556 11.842 17.0556 10.7222C17.0556 9.60242 16.6107 8.52848 15.8189 7.73666C15.0271 6.94484 13.9531 6.5 12.8333 6.5C11.7135 6.5 10.6396 6.94484 9.84777 7.73666C9.05595 8.52848 8.61111 9.60242 8.61111 10.7222Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCollaborate);
export default __webpack_public_path__ + "static/media/nav-collaborate.d34aba06106497ccc3783412d0bffd88.svg";
export { ForwardRef as ReactComponent };